<template>
  <div>
    <!-- begin #page-container -->
    <div id="page-container" class="page-container fade page-sidebar-fixed page-header-fixed">
      <!-- begin #header -->
      <div id="header" class="header navbar-default">
        <!-- begin navbar-header -->
        <div class="navbar-header">
          <a class="navbar-brand">
            <img src="@/assets/logo.png" style="margin-right:30px;">
            <b>中创</b> 分销
          </a>
          <button type="button" class="navbar-toggle" data-click="sidebar-toggled">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <!-- end navbar-header -->

        <!-- begin header-nav -->
        <ul class="navbar-nav navbar-right">
          <li class="dropdown navbar-user">
            <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
              <img src="../../static/img/user/user-13.jpg" alt>
              <span class="d-none d-md-inline">{{userName}}</span>
              <b class="caret"></b>
            </a>
          </li>
        </ul>
        <!-- end header navigation right -->
      </div>
      <!-- end #header -->

      <!-- begin #sidebar -->
      <div id="sidebar" class="sidebar">
        <!-- begin sidebar scrollbar -->
        <div data-scrollbar="true" data-height="100%">
          <!-- begin sidebar user -->
          <ul class="nav">
            <li class="nav-profile">
              <a href="javascript:;" data-toggle="nav-profile">
                <div class="cover with-shadow"></div>
                <div class="info">
                  <router-link to="/index" style="color:white;font-size:18px;text-decoration:none;">商城管理</router-link>
                </div>
              </a>
            </li>
          </ul>
          <!-- end sidebar user -->
          <!-- begin sidebar nav -->
          <ul class="nav">
            <li class="has-sub" @click="GoodsShelves">
              <a href="javascript:;">
                <b class="caret" v-if="!SideSelected"></b>
                <i class="fa fa-hdd"></i>
                <span class="hasTitle">商品上下架</span>
              </a>
            </li>
            <li class="has-sub" @click="LogoList">
              <a href="javascript:;">
                <b class="caret" v-if="!SideSelected"></b>
                <i class="fa fa-gem"></i>
                <span class="hasTitle">Logo配置</span>
              </a>
            </li>
            <li class="has-sub" @click="BannerList">
              <a href="javascript:;">
                <b class="caret" v-if="!SideSelected"></b>
                <i class="fa fa-gift"></i>
                <span class="hasTitle">Banner图配置</span>
              </a>
            </li>
            <li class="has-sub" @click="ClassifiedList">
              <a href="javascript:;">
                <b class="caret" v-if="!SideSelected"></b>
                <i class="fa fa-key"></i>
                <span class="hasTitle">分类列表配置</span>
              </a>
            </li>
            <li class="has-sub" @click="PageList">
              <a href="javascript:;">
                <b class="caret" v-if="!SideSelected"></b>
                <i class="fa fa-hdd"></i>
                <span class="hasTitle">页面分区配置</span>
              </a>
            </li>
<!--            <li class="has-sub" @click="giftList">-->
<!--              <a href="javascript:;">-->
<!--                <b class="caret" v-if="!SideSelected"></b>-->
<!--                <i class="fa fa-hdd"></i>-->
<!--                <span class="hasTitle">赠品库存列表</span>-->
<!--              </a>-->
<!--            </li>-->
            <li>
              <a class="sidebar-minify-btn" data-click="sidebar-minify" @click="SideClick">
                <i class="fa fa-angle-double-left"></i>
              </a>
            </li>
          </ul>
          <!-- end sidebar nav -->
        </div>
        <!-- end sidebar scrollbar -->
      </div>
      <!-- end #sidebar -->
      <div class="RightContent" :class="{'RightContentWidth':SideSelected}">
      <router-view></router-view>
      </div>
    </div>
    <!-- end page container -->

  </div>
</template>

<script>
export default {
  name: 'UserInterception',
  data () {
    return {
      userName:'',
      recom_id:'',
      SideSelected:false
    }
  },
  mounted: function() {
    if(localStorage.getItem('userName')){
      this.userName = JSON.parse(localStorage.getItem('userName')).userName;
    }
    if(this.$route.query.recomId){
      this.recom_id = this.$route.query.recomId;
    }
		App.init();
  },
  methods:{
    SideClick(){
      this.SideSelected = !this.SideSelected;
    },
    LogoList(){
      this.$router.push({
        path:'/logomanagement',
        name:'LogoManagement',
        query: {recomId:this.recom_id}
      });
    },
    BannerList(){
      this.$router.push({
        path:'/bannermanagement',
        name:'BannerManagement',
        query: {recomId:this.recom_id}
      });
    },
    ClassifiedList(){
      this.$router.push({
        path:'/classifiedmanagement',
        name:'ClassifiedManagement',
        query: {recomId:this.recom_id}
      });
    },
    TopnavList(){
      this.$router.push({
        path:'/topnavsetting',
        name:'TopnavSetting',
        query: {recomId:this.recom_id}
      });
    },
    PageList(){
      this.$router.push({
        path:'/pagemanagement',
        name:'PageManagement',
        query: {recomId:this.recom_id}
      });
    },
    GoodsShelves(){
      this.$router.push({
        path:'/goodsshelves',
        name:'GoodsShelves',
        query: {recomId:this.recom_id}
      });
    },
    giftList () {
      this.$router.push({
        path:'/giftInventory',
        name:'GiftInventory',
        query: {recomId:this.recom_id}
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.RightContent{
	width:calc(100% - 220px);
	float:right;
}
.RightContentWidth{
  width: calc(100% - 60px) !important;
}
.hasTitle {
  float: left;
  font-size: 12px;
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/MallSettingMenu.vue